module.exports = __webpack_public_path__ + "img/how-to-take-your-treatment.f3ff3735.png";